import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { has } from 'lodash';
import { GatsbyImage } from 'gatsby-plugin-image';

const PlainImageWrapper = styled.div`
    overflow: hidden;
    position: relative;
    width: 100%;
`;

const PlainImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: ${({ objectFit }) => objectFit ?? 'cover'};
`;

const FallbackImage = ({ alt, className, src, objectFit, objectPosition }) => (
    <PlainImageWrapper {...{ className }}>
        <PlainImage {...{ alt, src, objectFit, objectPosition }} />
    </PlainImageWrapper>
);

const Image = ({
    altText = '',
    className = '',
    localFile = {},
    sourceUrl,
    objectFit = 'cover',
    objectPosition = 'center center',
    id = ''
}) => {
    if (has(localFile, 'childImageSharp.gatsbyImageData')) {
        let width = localFile.childImageSharp.gatsbyImageData.width ?? '';
        let height = localFile.childImageSharp.gatsbyImageData.height ?? '';

        const useNoAspectRatio =
            objectFit === 'contain' &&
            has(localFile, 'childImageSharp.noAspectRatio');

        if (useNoAspectRatio) {
            if (has(localFile, 'childImageSharp.noAspectRatio.width')) {
                width = localFile.childImageSharp.noAspectRatio.width;
            }

            if (has(localFile, 'childImageSharp.noAspectRatio.height')) {
                height = localFile.childImageSharp.noAspectRatio.height;
            }
        }

        const imageProps = {
            className,
            objectFit,
            objectPosition,
            id
        };

        if (width) {
            imageProps.width = width;
        }

        if (height) {
            imageProps.height = height;
        }

        return (
            <GatsbyImage
                alt={altText}
                {...imageProps}
                image={
                    useNoAspectRatio
                        ? localFile.childImageSharp.noAspectRatio
                        : localFile.childImageSharp.gatsbyImageData
                }
            />
        );
    } else {
        return (
            <FallbackImage
                {...{ className, objectFit, objectPosition }}
                alt={altText}
                src={sourceUrl}
            />
        );
    }
};

Image.propTypes = {
    altText: PropTypes.string,
    className: PropTypes.string,
    localFile: PropTypes.shape({
        childImageSharp: PropTypes.shape({
            fluid: PropTypes.shape({})
        })
    }),
    objectFit: PropTypes.string,
    objectPosition: PropTypes.string,
    sourceUrl: PropTypes.string.isRequired,
    id: PropTypes.string
};

export default Image;
